<template lang="pug">
  component(
    v-bind="fieldProps"
    v-on="field.listeners"
    :is="field.component"
    :namespace="field.value"
  )
    template(
      v-for="(_, name) in $scopedSlots"
      v-slot:[name]="data"
    )
      slot(:name="name" v-bind="data")
    template(
      v-for="(_, name) in $slots"
      :slot="name"
    )
      slot(:name="name")
</template>

<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    additionalFieldProps() {
      const { $attrs, $props } = this;

      return Object.entries({ ...$attrs })
        .reduce((acc, [key, val]) => {
          if (key in $props) return acc;
          return { ...acc, [key]: val };
        }, {});
    },
    fieldProps() {
      const { field, additionalFieldProps } = this;

      return {
        label: field.label,
        ...field.props || {},
        ...additionalFieldProps,
      };
    },
  },
};
</script>
